import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import { AbstractErrorHandlerService, ErrorHelperService, ErrorPopupService, PopupDialogAction } from '@ddt-web/error-handler';

import { WatchlistErrorCode } from '../enums';

@Injectable()
export class WatchlistErrorHandlerService extends AbstractErrorHandlerService {
	private readonly ERRORS_TO_HANDLE = [WatchlistErrorCode.NO_TAGGED_FUNDS_ERROR];

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		if (this.ERRORS_TO_HANDLE.includes(error?.configName)) {
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = error.configName;
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			
			const message = this.contentService.get('NO_TAGGED_FUNDS', 'You have no funds with the selected tag!');

			const actions = [
				PopupDialogAction.create({
					label: this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL),
					type: 'view_new_analysis',
					reload: false
				})
			];

			this.errorPopupService.openResponseMessageDialog(
				this.buildErrorMessage(false, 'error-watchlist', this.errorMessage, this.trackErrorMessage, message, true, null, actions)
			);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
